import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Sidebar.css';
import { useAuth } from '../context/AuthContext';
import avatar from '../assets/avatar.jpg';

interface SidebarProps {
  onMenuClick: (menu: string) => void;
  activeMenu: string;
  isMobile?: boolean;
  isMobileMenuOpen?: boolean;
  onCloseMobileMenu?: () => void;
  onLogout?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ 
  onMenuClick, 
  activeMenu, 
  isMobile, 
  isMobileMenuOpen, 
  onCloseMobileMenu,
  onLogout 
}) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleProfileClick = () => {
    navigate('/profile');
    if (onCloseMobileMenu) {
      onCloseMobileMenu();
    }
  };

  const handleLogoutClick = () => {
    if (onLogout) {
      onLogout();
    }
    if (onCloseMobileMenu) {
      onCloseMobileMenu();
    }
  };

  // Desktop sidebar
  if (!isMobile) {
    return (
      <div className="sidebar">
        <nav className="sidebar-nav">
          <ul>
            <li>
              <button
                className={`menu-item ${activeMenu === 'Calendario' ? 'active' : ''}`}
                onClick={() => onMenuClick('Calendario')}
              >
                Calendario
              </button>
            </li>
            <li>
              <button
                className={`menu-item ${activeMenu === 'Articulos' ? 'active' : ''}`}
                onClick={() => onMenuClick('Articulos')}
              >
                Articulos
              </button>
            </li>
            <li>
              <button
                className={`menu-item ${activeMenu === 'Historias' ? 'active' : ''}`}
                onClick={() => onMenuClick('Historias')}
              >
                Historias
              </button>
            </li>
            <li>
              <button
                className={`menu-item ${activeMenu === 'Configuracion' ? 'active' : ''}`}
                onClick={() => onMenuClick('Configuracion')}
              >
                Configuración
              </button>
            </li>
            {user?.role === 'SUPERADMIN' && (
              <li>
                <button
                  className={`menu-item ${activeMenu === 'Admin' ? 'active' : ''}`}
                  onClick={() => onMenuClick('Admin')}
                >
                  Admin
                </button>
              </li>
            )}
          </ul>
        </nav>
      </div>
    );
  }

  // Mobile overlay menu
  return (
    <div className={`mobile-sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
      {/* Avatar Section */}
      <div className="mobile-avatar-section">
        <img
          src={user?.avatarSrc || avatar}
          alt="User Avatar"
          className="mobile-avatar-image"
        />
        <div className="mobile-user-greeting">Hola, {user?.firstname || 'User'}</div>
      </div>

      {/* Navigation Menu */}
      <nav className="mobile-nav">
        <ul>
          <li>
            <button
              className={`mobile-menu-item ${activeMenu === 'Calendario' ? 'active' : ''}`}
              onClick={() => onMenuClick('Calendario')}
            >
              Calendario
            </button>
          </li>
          <li>
            <button
              className={`mobile-menu-item ${activeMenu === 'Articulos' ? 'active' : ''}`}
              onClick={() => onMenuClick('Articulos')}
            >
              Articulos
            </button>
          </li>
          <li>
            <button
              className={`mobile-menu-item ${activeMenu === 'Historias' ? 'active' : ''}`}
              onClick={() => onMenuClick('Historias')}
            >
              Historias
            </button>
          </li>
          <li>
            <button
              className={`mobile-menu-item ${activeMenu === 'Configuracion' ? 'active' : ''}`}
              onClick={() => onMenuClick('Configuracion')}
            >
              Configuración
            </button>
          </li>
          {user?.role === 'SUPERADMIN' && (
            <li>
              <button
                className={`mobile-menu-item ${activeMenu === 'Admin' ? 'active' : ''}`}
                onClick={() => onMenuClick('Admin')}
              >
                Admin
              </button>
            </li>
          )}
        </ul>
      </nav>

      {/* Profile and Logout Section */}
      <div className="mobile-actions">
        <button className="mobile-action-item" onClick={handleProfileClick}>
          <i className="fas fa-user"></i>
          Perfil
        </button>
        <button className="mobile-action-item logout" onClick={handleLogoutClick}>
          <i className="fas fa-sign-out-alt"></i>
          Cerrar sesión
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
